const header = {
    data: new Map([
        ['menuLinks', 
            [
                {
                    type:`internal-link`,
                    href: `/#schedule`,
                    label: `Schedule`,
                },
                {
                    type:`internal-link`,
                    href: `/#find-us`,
                    label: `Find Us`,
                },
            ]
        ],
        ['logoItems', 
            [
                {
                    image: {
                        url: 'https://ewscripps-brightspot-lower.s3.amazonaws.com/b5/63/73d728894ffe9c98564d5db1019d/ion-herologo-white.png', 
                        width: 80, 
                        height: 51,
                        altText: 'ION Television logo, to the homepage',
                    },
                    href: `https://iontelevision.com`,
                    height: 2.5,
                    baselineAdjustment: 0.3,
                    text: '',
                },
                {
                    image: {
                        url: `https://ewscripps.brightspotcdn.com/49/4d/5a318d674693acf269a7cad94081/button-ion-plus-logo-2x.png`,
                        width: 250,
                        height: 100,
                        altText: `ION Plus logo, go to ION Plus`,
                    },
                    href: `https://ionplustv.com`,
                    height: 2.1,
                    baselineAdjustment: 0,
                    text: '',
                },
            ]
        ]
    ])
}

const footer = {
    data: new Map([
        ['navSections', 
            [
                {
                    "title": "Site Navigation",
                    "links": [
                        {
                            "href": "/#schedule",
                            "type": "internal-link",
                            "label": "Schedule"
                        },
                        {
                            "href": "/#find-us",
                            "type": "internal-link",
                            "label": "Find Us"
                        }
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Networks",
                    "links": [
                        {
                            "href": "https://iontelevision.com",
                            "type": "internal-link",
                            "label": "ION"
                        },
                        {
                            "href": "https://ionplustv.com",
                            "type": "internal-link",
                            "label": "ION Plus"
                        },
                        {
                            "href": "https://ionmystery.com",
                            "type": "internal-link",
                            "label": "ION Mystery"
                    }
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Privacy & Terms",
                    "links": [
                        {
                            "href": "https://scripps.com/privacy-policy",
                            "type": "external-link",
                            "label": "Privacy Policy"
                        },
                        {
                            "href": "https://iontelevision.com/terms-of-use",
                            "type": "external-link",
                            "label": "Terms of Use"
                        },
                        {
                            "href": "https://scripps.com/privacy-center",
                            "type": "external-link",
                            "label": "Privacy Center"
                        },
                        {
                            "href": "#",
                            "type": "internal-link",
                            "label": "Do Not Sell My Info",
                            "classname": "privacy-preferences-trigger",
                        },
                    ],
                    "classname": "footer-nav"
                },
                {
                    "title": "Information",
                    "links": [
                        {
                            "href": "https://support.iontelevision.com/support/solutions",
                            "type": "external-link",
                            "label": "Help / FAQs"
                        },
                        {
                            "href": "https://support.iontelevision.com/support/home",
                            "type": "external-link",
                            "label": "Contact Us"
                        },
                    ],
                    "classname": "footer-nav"
                }
            ]
        ],
        ['socialLinks',
            [
                {
                    platform: 'facebook',
                    url: 'https://www.facebook.com/IONTelevision',
                },
                {
                    platform: 'twitter',
                    url: 'https://twitter.com/iontv/',
                    viewBox: '0 0 30 30',
                },
                {
                    platform: 'instagram',
                    url: 'https://www.instagram.com/iontelevision/',
                },
                {
                    platform: 'tiktok',
                    url: 'https://www.tiktok.com/@iontelevision?lang=en',
                    viewBox: '0 0 30 30',
                },
                {
                    platform: 'youtube',
                    url: 'https://www.youtube.com/@ion.television',
                },
            ]
        ],
    ])  
}

const resources = new Map([
    ['header', header],
    ['footer', footer],
])

export {
    resources,
}